import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DatepickerInput, Modal, Button, Portal } from 'next-common-lib';
import moment from 'moment';
import { getUserInfoAPI } from '../../apis/userApi';
import useCalculatePosition from '../../hooks/useCalculatePosition';
import util from '../../lib/ultils';
import './DueDateTodoPopup.scss';

const DueDatePopup = ({
  btnRect,
  onSelectedData,
  edgeMode,
  renderDelayDate,
  existDate,
  setShowDueDatePopup,
  showDueDatePopup,
  isRemoveAll,
  dateFormat,
}) => {
  const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
  const [t] = useTranslation('contacts');
  const [clickRangeTarget, setClickRangeTarget] = useState('S'); // String 날짜값
  const [resetRange, setResetRange] = useState(false);
  const [checkClickE, setCheckClickE] = useState(false);
  const [value, setValue] = useState('');
  const startDateFieldRef = useRef(null);
  const endDateFieldRef = useRef(null);
  const modalRef = useRef(null);

  const modalPosition = edgeMode ? { top: 0, left: 0 } : useCalculatePosition(btnRect, modalRef);

  const [rangeValueState, setRangeValueState] = useState({
    S: '',
    E: '',
  });

  const { elementRef: popupRow } = util.detectClickOutSide(() => {
    if (edgeMode) {
      setShowDueDatePopup(false);
    }
  });

  // const refocus = element => {
  //   const lastednode = element.childNodes[element.childNodes.length - 1];
  //   if (!lastednode) {
  //     element.focus();
  //     return;
  //   }
  //   const selection = window.getSelection();
  //   selection.collapse(lastednode, lastednode.length);
  // };
  const [userInfoLogin, setUserInfoLogin] = useState(null);
  const [isLimitDate, setLimitDate] = useState({
    limitStart: false,
    limitEnd: false,
  });

  const fetchUserInfo = async () => {
    const [userInfo] = await Promise.all([getUserInfoAPI()]);
    setUserInfoLogin(userInfo);
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  // calculate max date
  const isMoreThanTenYears = (startDate, endDate) => {
    if (startDate.length === 0 || endDate.length === 0) return false;
    const sDate = new Date(startDate);
    const eDate = new Date(endDate);
    const diffInYears = Math.abs(eDate - sDate) / (1000 * 60 * 60 * 24 * 365);
    return diffInYears > 10;
  };

  useEffect(() => {
    if (isLimitDate.limitStart || isLimitDate.limitEnd) {
      const noticeId = 'open-notice-popup';
      const closeMess = e => {
        e.stopPropagation();
        setLimitDate({
          limitStart: false,
          limitEnd: false,
        });
        setRangeValueState({
          S: !isLimitDate.limitStart ? rangeValueState.S : '',
          E: !isLimitDate.limitEnd ? rangeValueState.E : '',
        });
        Portal.close(noticeId);
      };

      Portal.open('popup', noticeId, {
        theme: userInfoLogin?.DARKMODEYN === 'Y' ? 'dark' : 'light',
        size: edgeMode ? 'xxs' : 'xs',
        titleComponent: [<h1 className="popup-title">{t('contacts.common.text.notice')}</h1>],
        messageComponent: [t('task.notice.limit.date.gantt')],
        buttonComponent: [
          <Button color="primary" label={t('contacts.searchPeopleContactsTab.text.ok')} onClick={closeMess} />,
        ],
        closeFunction: closeMess,
        isDimed: true,
        zIndex: 9999,
      });
    }
  }, [isLimitDate]);

  const focusDateField = field => {
    const isEndDateField = field === 'E';
    setCheckClickE(isEndDateField);
    setClickRangeTarget(field);
  };

  useEffect(() => {
    if (existDate.startDate.length > 0) {
      setValue(existDate.startDate);
      focusDateField('S');
    } else {
      setValue(existDate.endDate);
      focusDateField('E');
    }

    setResetRange(true);
    setRangeValueState({ S: existDate.startDate, E: existDate.endDate });
  }, [existDate.startDate, existDate.endDate, existDate.onLoad]);

  const handleClickReset = () => {
    setRangeValueState({ S: '', E: '' });
    onSelectedData({ startDate: '', endDate: '' });
  };
  const validateRange = (start, end) => {
    const isOurOfRange = moment(end, dateFormat).isBefore(moment(start, dateFormat));
    return isOurOfRange ? [checkClickE ? end : start, '', isOurOfRange] : [start, end, isOurOfRange];
  };
  const updatePeriod = (startDate, endDate) => {
    const [newStart, newEnd, isOutRange] = validateRange(startDate, endDate);
    setRangeValueState({
      S: newStart,
      E: newEnd,
    });
    if (isMoreThanTenYears(newStart, newEnd)) {
      setLimitDate({
        limitStart: true,
        limitEnd: false,
      });
      return;
    }
    if (isOutRange) {
      focusDateField('E');
      return;
    }
    onSelectedData({ startDate: newStart, endDate: newEnd });
    setShowDueDatePopup(false);
  };

  const onClickDatepickerRange = returnRangeValue => {
    const startVal = util.convertFormatDate(returnRangeValue.S || '', DEFAULT_DATE_FORMAT, dateFormat);
    const endVal = util.convertFormatDate(returnRangeValue.E || '', DEFAULT_DATE_FORMAT, dateFormat);
    const selectedValue = startVal === '' ? endVal : endVal === '' ? startVal : startVal === value ? endVal : startVal;
    setValue(selectedValue);

    if (!checkClickE) {
      const isUpdateStartDateOnly = !rangeValueState.S && Boolean(rangeValueState.E);
      if (isUpdateStartDateOnly) {
        updatePeriod(selectedValue, rangeValueState.E);
        return;
      }
      setRangeValueState({ S: selectedValue, E: '' });
      focusDateField('E');
      return;
    }
    updatePeriod(rangeValueState.S, selectedValue);
  };

  const isNotEmptyModal = id => {
    const popDiv = document.getElementById(id);
    return popDiv?.childNodes && popDiv.childNodes.length !== 0;
  };

  return (
    <Modal
      ref={modalRef}
      id="due-date-popup"
      isShow={showDueDatePopup}
      top={edgeMode ? modalPosition.top : `${modalPosition.top}px`}
      left={edgeMode ? modalPosition.left : `${modalPosition.left}px`}
      outSideClick={() => {
        if (isNotEmptyModal('open-notice-popup')) return;
        setShowDueDatePopup(false);
      }}
      isInnerDivModal={edgeMode}
      className={edgeMode ? (renderDelayDate ? 'render-delay' : 'finish-load') : ''}
      height="350px"
      width="310px"
    >
      <div className="popup xxs" ref={popupRow}>
        <div className="datepicker-wrap">
          <div className="datepicker-new">
            <div className="datepicker-date-input">
              <div className="datepicker-wrap">
                <div className="datepicker-date-input">
                  <div className={`input-group ${clickRangeTarget === 'S' && resetRange ? 'active' : ''}`}>
                    <div
                      style={{ paddingLeft: '8px', width: '100%' }}
                      className="form-control"
                      ref={startDateFieldRef}
                      contentEditable
                      suppressContentEditableWarning="true"
                      placeholder={t('contacts.popup.text.startDateTodo')}
                      onKeyDown={e => {
                        e.preventDefault();
                      }}
                      onKeyUp={e => {
                        e.preventDefault();
                      }}
                      onClick={e => {
                        e.stopPropagation();
                        focusDateField('S');
                        setResetRange(true);
                      }}
                    >
                      {rangeValueState.S}
                    </div>
                  </div>
                </div>
              </div>
              <div className="datepicker-wrap">
                <div className="datepicker-date-input">
                  <div className={`input-group ${clickRangeTarget === 'E' && resetRange ? 'active' : ''}`}>
                    <div
                      style={{ paddingLeft: '8px', width: '100%' }}
                      className="form-control"
                      ref={endDateFieldRef}
                      contentEditable
                      suppressContentEditableWarning="true"
                      placeholder={t('contacts.popup.text.dueDateTodo')}
                      onKeyDown={e => {
                        e.preventDefault();
                      }}
                      onKeyUp={e => {
                        e.preventDefault();
                      }}
                      onClick={e => {
                        focusDateField('E');
                        setResetRange(true);
                      }}
                    >
                      {rangeValueState.E}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <DatepickerInput
              componentType="range"
              autoSetValue={false}
              onClick={onClickDatepickerRange}
              value={util.convertFormatDate(value || new Date(), dateFormat, DEFAULT_DATE_FORMAT)}
              rangeValue={{
                S: util.convertFormatDate(rangeValueState.S, dateFormat, DEFAULT_DATE_FORMAT),
                E: util.convertFormatDate(rangeValueState.E, dateFormat, DEFAULT_DATE_FORMAT),
              }}
              clickRangeTarget={clickRangeTarget}
              dateFormat={DEFAULT_DATE_FORMAT}
            />
            {isRemoveAll && (
              <div className="btn-group">
                <Button
                  componentType="button"
                  className="link"
                  label={t('contacts.popup.taskPhaseTwo.removeAll')}
                  size="xs"
                  onClick={() => {
                    handleClickReset();
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

DueDatePopup.propTypes = {
  btnRect: PropTypes.object,
  onSelectedData: PropTypes.func,
  edgeMode: PropTypes.bool,
  renderDelayDate: PropTypes.bool,
  existDate: PropTypes.object,
  setShowDueDatePopup: PropTypes.func,
  showDueDatePopup: PropTypes.bool,
  isRemoveAll: PropTypes.bool,
  dateFormat: PropTypes.string,
};

DueDatePopup.defaultProps = {
  btnRect: {},
  onSelectedData: () => {},
  edgeMode: false,
  renderDelayDate: false,
  existDate: {
    startDate: '',
    endDate: '',
  },
  setShowDueDatePopup: () => {},
  showDueDatePopup: false,
  isRemoveAll: true,
  dateFormat: 'YYYY-MM-DD',
};

export default DueDatePopup;
